<template>
  <div>
    <div
      v-show="showing"
      class="fixed pt-24 pb-10 inset-0 w-full h-screen flex items-center justify-center bg-semi-75 z-20"
    >
      <div class="mx-2 w-full max-w-xl max-h-full bg-white shadow-lg rounded-lg p-5 overflow-auto">
        <div class="w-full text-right sticky top-0 right-0">
          <button aria-label="close" class="text-xl text-gray-500" @click.prevent="close">×</button>
        </div>
        <div class="flex flex-wrap">
          <div
            v-if="!newComplaintCategory"
            class="w-full text-left px-3 pb-3 text-teal-700 text-2xl font-bold"
          >Actualización de categoría de denuncia</div>
          <div
            v-if="newComplaintCategory"
            class="w-full text-left px-3 pb-3 text-teal-700 text-2xl font-bold"
          >Nueva categoría de denuncia</div>

          <div class="flex flex-col w-full pl-4">
            <form class="w-full max-w-lg" id="ComplaintCategoryForm" @submit.prevent>
              <div class="flex flex-wrap -mx-3">
                <div class="w-full px-3 mb-6 md:mb-0">
                  <label
                    class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                    for="name"
                  >Categoría *</label>
                  <input
                    class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                    id="name"
                    type="text"
                    name="name"
                    v-model="complaintCategory.name"
                  />
                  <p
                    v-if="errors.name"
                    class="text-red-500 text-xs italic"
                  >Ingrese una categoría de denuncia.</p>
                  
                  <label
                    class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                    for="email"                  
                  >Correo<span class="text-gray-500 italic"> (separado por comas)</span></label>
                  <input
                    v-show="false"
                    class="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    id="email"
                    type="text"
                    email="email"
                    name="email"
                    v-model="complaintCategory.email"
                  />
                  <p
                    v-if="errors.email"
                    class="text-red-500 text-xs italic"
                  >Ingrese un correo.</p>
                </div>
              </div>

              <div class="flex w-full justify-end">
                <button
                  class="bg-blue-500 hover:bg-blue-700 px-4 py-2 text-center rounded-lg text-gray-100 tracking-wide"
                  @click="saveComplaint()"
                >Guardar</button>
                <button
                  class="ml-2 bg-red-500 hover:bg-red-700 px-4 py-2 text-center rounded-lg text-gray-100 tracking-wide"
                  @click="close()"
                >Cerrar</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <alert-dialog :showing="showingSuccess">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Categoría guardada exitosamente</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-green-400"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingSuccess = false"
        >Cerrar</button>
      </div>
    </alert-dialog>
    <alert-dialog :showing="showingError">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">{{errors.codeError}}</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-red-400"
            viewBox="0 0 24 24"
          >
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingError = false"
        >Cerrar</button>
      </div>
    </alert-dialog>
  </div>
</template>

<script>
import config from "../../vue.config.js";
import { backend_url } from "../config/url.config.ts";
import EventBus from "../event-bus";
import AlertDialog from "./AlertDialog";
import Tagify from "@yaireo/tagify";

export default {
  name: "complaintCategory-modal",
  data() {
    return {
      aux_complaintCategory: null,
      complaintCategory: {
        name: null,
        enable: null,
        email: null,
        id: null
      },
      themesTagify: [],
      errors: {
        name: false,
        codeError: "Ha ocurrido un error"
      },
      showingSuccess: false,
      showingError: false,
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken")
        }
      }
    };
  },
  props: {
    showing: {
      required: true,
      type: Boolean
    },
    newComplaintCategory: {
      required: true,
      type: Boolean
    }
  },
  watch: {
    showing(value) {
      if (value) {
        return document.querySelector("body").classList.add("overflow-hidden");
      }

      document.querySelector("body").classList.remove("overflow-hidden");
    }
  },
  mounted() {
    EventBus.$on("editModal", this.setData);
    EventBus.$on("newModal", this.newData);

    let themesInput = document.querySelector('input[name="email"]');
    this.themesTagify = new Tagify(themesInput);
  },
  components: {
    AlertDialog
  },
  methods: {
    reset: function() {
      this.complaintCategory = {
        name: null,
        email: null,
        enable: null,
        id: null
      };
      this.errors = {
        name: false,
        codeError: "Ha ocurrido un error"
      };
    },

    close() {
      this.reset();
      this.$emit("close");
    },

    newData: function() {
      this.themesTagify.removeAllTags();
    },

    setData: function(authority) {
      this.themesTagify.removeAllTags();
      this.complaintCategory = Object.assign({}, authority);
      this.aux_complaintCategory = Object.assign({}, authority);
      this.complaintCategory.email.split(",").forEach(data=>{
        this.themesTagify.addTags(data)
      })
    },

    saveComplaint() {
      const form = document.getElementById("ComplaintCategoryForm");
      const signInData = new FormData(form);

      if (this.newComplaintCategory) {
        const validForm = this.checkFormNewComplaintCategory(signInData);
        if (validForm) {
          let string_email = this.formatEmails(this.themesTagify.value);

          //implement code for create new complaintCategory
          this.axios
            .post(
              backend_url + "/visitors/complaint/categories",
              {
                name: this.complaintCategory.name,
                email: string_email
                //email: this.complaintCategory.email
              },
              this.config
            )
            .then(response => {
              return this.axios.post(backend_url+"/api/binnacles/monitor/save/",{
                "module": "Configuración", 
                "action": "Creación de una categoría de denuncia", 
                "observation": this.complaintCategory.name,
                "email": localStorage.getItem("email")
                },
                this.config
              )
            })
            .then(response => {
              this.showingSuccess = true;
              this.$emit("updateAllComplaintCategories");
              this.reset();
              this.$emit("close");
            })
            .catch(error => {
              console.error(error.response);
              if (error.response.status == 409) {
                this.errors.codeError =
                  "Ya hay otra categoría con ese nombre. Pruebe con otro nombre";
              }
              if (error.response.status == 400 || error.response.status == 401) {
                if (error.response.data.name === 'TokenExpiredError' || 
                    error.response.data.name === 'InvalidTokenError' || 
                    error.response.data.name === 'JsonWebTokenError') {
                  this.$router.push({path: '/login'}); 
                }
              }
              this.showingError = true;
            });
        }
      } else {
        const validForm = this.checkFormUpdateComplaintCategory(signInData);
        if (validForm) {
          let string_email = this.formatEmails(this.themesTagify.value);
          this.axios
            .put(
              backend_url + "/visitors/complaint/categories",
              {
                name: this.complaintCategory.name,
                enabled: this.complaintCategory.enabled,
                email: string_email,
                //email: this.complaintCategory.email,
                id: this.complaintCategory.id
              },
              this.config
            )
            .then(response => {
              let observation = ""
              if(this.complaintCategory.name != this.aux_complaintCategory.name){
                observation = `${this.aux_complaintCategory.name} / ${this.complaintCategory.name}`
              } else {
                observation = `${this.complaintCategory.name}`
              }
              
              return this.axios.post(backend_url+"/api/binnacles/monitor/save/",{
                "module": "Configuración", 
                "action": "Edición de una categoría de denuncia", 
                "observation": observation,
                "email": localStorage.getItem("email")
                },
                this.config
              )
            })
            .then(response => {
              this.showingSuccess = true;
              this.complaintCategory.email = string_email;
              this.$emit("updateComplaintCategoryModal", this.complaintCategory);
              this.reset();
              this.$emit("close");
            })
            .catch(error => {
              console.error(error.response);
              if (error.response.status == 400 || error.response.status == 401) {
                if (error.response.data.name === 'TokenExpiredError' || 
                    error.response.data.name === 'InvalidTokenError' || 
                    error.response.data.name === 'JsonWebTokenError') {
                this.$router.push({path: '/login'}); 
                }
              }
              this.showingError = true;
            });
        }
      }
    },

    checkFormNewComplaintCategory: function(signInData) {
      if (signInData.get("name") === "") {
        this.errors.name = true;
      } else {
        this.errors.name = false;
      }

      if (this.errors.name) {
        return false;
      }

      return true;
    },

    checkFormUpdateComplaintCategory: function(signInData) {
      if (signInData.get("name") === "") {
        this.errors.name = true;
      } else {
        this.errors.name = false;
      }

      if (this.errors.name) {
        return false;
      }

      return true;
    },
    formatEmails: function(data){
      if(data.length > 0){
        let string_emails = "";
        data.forEach(email=>{  
          string_emails += email.value + ",";
        })
        string_emails = string_emails.slice(0,-1)
        return string_emails;
      }
      return "";
    }

  }
};
</script>
<style>
  @import '../../node_modules/@yaireo/tagify/dist/tagify.css';
</style>

<style scoped>    
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}
.text-teal-700 {
  color: #6e5b25;
}
</style>
